import { type FormEvent, useState } from 'react';
import { useNavigate } from 'react-router';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import XwordsUtils from './XwordsUtils';

interface Props {
    lang: MultiLang;
    type: number;
    catId: number;
    andor: string;
    term: string;
}

const XwordsSearchFieldset = (props: Props) => {
    const { lang } = props;
    const navigate = useNavigate();
    const [type, setType] = useState(props.type);
    const [catId, setCatId] = useState(props.catId);
    const [andor, setAndor] = useState(props.andor);
    const [term, setTerm] = useState(props.term);

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const term_ = term.trim();
        if (term_.length > 0) {
            void navigate(XwordsUtils.getSearchUrl(type, catId, andor, term_));
        }
    };

    const categories = XwordsUtils.getCategories();
    return (
        <fieldset className="item search">
            <legend className="title">{Functions.mlang('[en]Search[/en][ja]検索[/ja]', lang)}</legend>
            <div className="body">
                <form onSubmit={handleSubmit}>
                    <dl>
                        <dt>{Functions.mlang('[en]Target[/en][ja]検索対象[/ja]', lang)}</dt>
                        <dd>
                            <select onChange={(event) => setType(parseInt(event.target.value.trim(), 10))} value={type}>
                                <option value="1">{Functions.mlang('[en]Term[/en][ja]見出し語[/ja]', lang)}</option>
                                <option value="2">{Functions.mlang('[en]Yomi[/en][ja]読み方[/ja]', lang)}</option>
                                <option value="3">{Functions.mlang('[en]Definition[/en][ja]説明文[/ja]', lang)}</option>
                                <option value="4">
                                    {Functions.mlang(
                                        '[en]Term+Yomi+Definition[/en][ja]見出し語+読み方+説明文[/ja]',
                                        lang
                                    )}
                                </option>
                            </select>
                        </dd>
                        <dt>{Functions.mlang('[en]Category[/en][ja]用途別分類[/ja]', lang)}</dt>
                        <dd>
                            <select
                                onChange={(event) => setCatId(parseInt(event.target.value.trim(), 10))}
                                value={catId}
                            >
                                <option value="0">
                                    {Functions.mlang('[en]ANY[/en][ja]全分類（カテゴリー）[/ja]', lang)}
                                </option>
                                {categories.map((value) => (
                                    <option key={value.id} value={value.id}>
                                        {Functions.mlang(value.name, lang)}
                                    </option>
                                ))}
                            </select>
                        </dd>
                        <dt>{Functions.mlang('[en]Condition[/en][ja]検索の種類[/ja]', lang)}</dt>
                        <dd>
                            <select onChange={(event) => setAndor(event.target.value.trim())} value={andor}>
                                <option value="AND">
                                    {Functions.mlang('[en]AND[/en][ja]すべての語に一致するもの[/ja]', lang)}
                                </option>
                                <option value="OR">
                                    {Functions.mlang('[en]OR[/en][ja]いずれかの語に一致するもの[/ja]', lang)}
                                </option>
                                <option value="EXACT">
                                    {Functions.mlang('[en]EXACT[/en][ja]スペースも含め１語として[/ja]', lang)}
                                </option>
                            </select>
                        </dd>
                        <dt>{Functions.mlang('[en]Word[/en][ja]検索語[/ja]', lang)}</dt>
                        <dd>
                            <input
                                type="text"
                                name="term"
                                onChange={(event) => setTerm(event.target.value)}
                                value={term}
                            />
                            <input
                                className="formButton"
                                type="submit"
                                value={Functions.mlang('[en]Search![/en][ja]検索！[/ja]', lang)}
                            />
                        </dd>
                    </dl>
                </form>
            </div>
        </fieldset>
    );
};

export default XwordsSearchFieldset;
